import { useState } from 'react';
import { CourseListItem } from '../../../../../../../db/courses/types';
import { ClassListItem } from '../../../../../../../db/classes/types';
import { useAppContext } from '../../../../../../../app/Context';
import { FormValues as IntroductionFormValues } from '../../../../../../shared/TileIntroductionForm/types';
import { setCopyActivitySkipIntroduction } from '../../../../../../../db/polls';
import { useNavigate, useParams } from 'react-router-dom';
import routes, { PollParams } from '../../../../../../../routes/router';
import { copyActivity } from '../../../../../../../db/class-activities';
import { ClassActivityPluralTypes } from '../../../../../../../db/class-activities/types';
import { setActivityType } from '../../../../../../../db/shared';
import { enumFromStringValue } from '../../../../../../../utils/string';
import { SlideType } from '../../../../../../../db/shared/types';
import Logger from '../../../../../../../utils/logger';

export interface UseReusePollSteps {
  goToNextStep: () => void;
}

const useReusePollSteps = ({ goToNextStep }: UseReusePollSteps) => {
  const { universitySlug, pollId, slideType: slideTypeValues } = useParams<PollParams>();
  const slideType = enumFromStringValue(SlideType, slideTypeValues);

  const { presentationId, activeSlideId } = useAppContext();

  const [isBlocking, setIsBlocking] = useState(false);

  const navigate = useNavigate();

  const [selectedCourse, setSelectedCourse] = useState<CourseListItem | null>(null);
  const [selectedClass, setSelectedClass] = useState<ClassListItem | null>(null);

  const handleClickIntroductionNext = (data: IntroductionFormValues) => {
    setCopyActivitySkipIntroduction(data.doNotShowAgain);
    goToNextStep();
  };

  const handleClickCourseSelectionNext = (data: { selectedCourse: CourseListItem }) => {
    setSelectedCourse(data.selectedCourse);
    goToNextStep();
  };

  const handleClickClassSelectionNext = async (data: { selectedClass: ClassListItem }) => {
    if (!presentationId) return;
    if (!activeSlideId) return;
    if (!universitySlug) return;
    if (!slideTypeValues) return;
    if (!slideType) return;
    if (!selectedCourse?.courseId) return;
    if (!pollId) return;

    setSelectedClass(data.selectedClass);

    try {
      setIsBlocking(true);
      const response = await copyActivity({
        activityId: pollId,
        activityType: ClassActivityPluralTypes.POLLS,
        destinationClassId: data.selectedClass.classId,
        destinationCourseId: selectedCourse.courseId,
      });

      const { newCourseId, newClassId, newActivityId } = response;

      const pollUrl = routes.poll.url({
        universitySlug,
        courseId: newCourseId,
        classId: newClassId,
        pollId: newActivityId,
        slideType: slideTypeValues,
      });

      setActivityType(presentationId, activeSlideId, slideType, pollUrl);
      navigate(pollUrl);
    } catch (error) {
      Logger.error(error);
    } finally {
      setIsBlocking(false);
    }
  };

  return {
    isBlocking,
    selectedCourse,
    selectedClass,
    handleClickIntroductionNext,
    handleClickCourseSelectionNext,
    handleClickClassSelectionNext,
  };
};

export default useReusePollSteps;
